module.exports = __webpack_public_path__ + "img/service-resource.32ba8422.png";